export const AUTH_PV_USER = "AUTH_PV_USER";
export const lOGOUT_PV_USER = "lOGOUT_PV_USER";
export const PV_USER_DETAILS = "PV_USER_DETAILS";
export const PV_URL_DETAILS = "PV_URL_DETAILS";
